import React from 'react';
import type { GetServerSideProps } from 'next';

import { DeviceProvider } from 'contexts/DeviceContext';

import PublicV2, { PublicV2Props } from 'components/publicWebsiteV2/PublicV2';
import Passcode from 'components/publicWebsiteV2/pages/Passcode';

import { srrGetPasscodePage } from 'components/publicWebsiteV2/api/server/publicWebsiteSSRApiHelpers';

const PasscodePage = ({
  wedding,
  userAgent,
}: PublicV2Props & { userAgent?: string }): JSX.Element => (
  <DeviceProvider userAgent={userAgent}>
    <PublicV2 wedding={wedding}>
      <Passcode />
    </PublicV2>
  </DeviceProvider>
);

export const getServerSideProps: GetServerSideProps = async ({ req, res, query }) => {
  const { slug } = query;
  const { passcode } = req.cookies;
  if (passcode) {
    res.writeHead(302, {
      Location: `/wedding/${slug}`,
    });
    res.end();
    return { props: {} }; // stop execution
  }

  const weddingData = await srrGetPasscodePage(slug as string);

  if (!weddingData) {
    return {
      notFound: true,
    };
  }

  const userAgent = req.headers['user-agent'];

  return {
    props: JSON.parse(
      JSON.stringify({
        wedding: weddingData,
        userAgent,
      })
    ),
  };
};

export default PasscodePage;
